"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameMode4x4 = exports.validatorStraight = exports.validatorFlush = exports.validatorFourOfAKind = exports.validator4x4Blackjack = exports.validator4x413 = exports.validator4x4Ascending = exports.validator4x4Match = exports.validatorAll = void 0;
const CTGGameMode_1 = require("./CTGGameMode");
const CTGCard_1 = require("../Logic/CTGCard");
function validatorAll(mode, all, selected) {
    if (selected.length < 1)
        return;
    selected[0].destroy(true);
}
exports.validatorAll = validatorAll;
function validator4x4Match(mode, all, selected) {
    if (selected.length < 2) {
        return;
    }
    deselect_or_destroy(mode, selected, selected[0].equals(selected[1]));
}
exports.validator4x4Match = validator4x4Match;
function validator4x4Ascending(mode, all, selected) {
    if (selected.length < 1) {
        return;
    }
    let rank = selected[0].rank;
    for (let card of all) {
        if (card.rank < rank) {
            mode.set_selection_no_validation(selected[0], false);
            return;
        }
    }
    selected[0].destroy(true);
}
exports.validator4x4Ascending = validator4x4Ascending;
function validator4x413(mode, all, selected) {
    if (selected.length < 1) {
        return;
    }
    if (selected[0].rank == CTGCard_1.CTGRank.King) {
        selected[0].destroy(true);
        return;
    }
    if (selected.length < 2) {
        return;
    }
    deselect_or_destroy(mode, selected, selected[0].rank + selected[1].rank == CTGCard_1.CTGRank.King);
}
exports.validator4x413 = validator4x413;
function validator4x4Blackjack(mode, all, selected) {
    if (selected.length < 2)
        return;
    let max_value = 21;
    let value = 0;
    for (let card of selected) {
        if (card.rank == CTGCard_1.CTGRank.Ace) {
            max_value += 10;
            value += 10;
        }
        value += card.blackjackMinValue();
    }
    if (value > max_value) {
        selected.forEach(element => {
            mode.set_selection_no_validation(element, false);
        });
    }
    else if (value > 11 && value % 10 == 1) {
        selected.forEach(element => {
            element.destroy(true);
        });
    }
}
exports.validator4x4Blackjack = validator4x4Blackjack;
function validatorFourOfAKind(mode, all, selected) {
    if (selected.length < 4)
        return;
    deselect_or_destroy(mode, selected, selected[0].rank == selected[1].rank
        && selected[0].rank == selected[2].rank
        && selected[0].rank == selected[3].rank);
}
exports.validatorFourOfAKind = validatorFourOfAKind;
function validatorFlush(mode, all, selected) {
    if (selected.length < 5)
        return;
    deselect_or_destroy(mode, selected, selected[0].suit == selected[1].suit
        && selected[0].suit == selected[2].suit
        && selected[0].suit == selected[3].suit
        && selected[0].suit == selected[4].suit);
}
exports.validatorFlush = validatorFlush;
function validatorStraight(mode, all, selected) {
    if (selected.length < 5)
        return;
    selected.sort((a, b) => a.rank > b.rank ? 1 : -1);
    deselect_or_destroy(mode, selected, (selected[0].rank == selected[1].rank - 1 || (selected[0].rank == CTGCard_1.CTGRank.Ace && selected[1].rank == CTGCard_1.CTGRank.Ten))
        && selected[1].rank == selected[2].rank - 1
        && selected[2].rank == selected[3].rank - 1
        && selected[3].rank == selected[4].rank - 1);
}
exports.validatorStraight = validatorStraight;
function deselect_or_destroy(mode, selected, destroy) {
    if (destroy) {
        selected.forEach(element => {
            element.destroy(true);
        });
    }
    else {
        selected.forEach(element => {
            mode.set_selection_no_validation(element, false);
        });
    }
}
class CTGGameMode4x4 extends CTGGameMode_1.CTGGameMode {
    constructor(generator, validator, difficulty_mod, min_cards, clear_to_win, animators) {
        super(animators);
        this.generator = generator;
        this.validator = validator;
        this.difficulty_mod = difficulty_mod;
        this.min_cards = min_cards;
        this.clear_to_win = clear_to_win;
        this.win_on_time_out = false;
        this._cards = [];
        this._selected = [];
    }
    set_selection_no_validation(card, selected, from_bad_move = true) {
        card.set_selected(selected, true);
        if (card.is_selected) {
            this._selected.push(card);
        }
        else {
            if (from_bad_move)
                card.invalid_press();
            this._selected = this._selected.filter(function (el) { return el != card; });
        }
    }
    toggle_selected(card) {
        this.set_selection_no_validation(card, !card.is_selected, false);
        this.validator(this, this._cards, this._selected);
    }
    card_tapped(card) {
        // card.flip(!card.showing_front, true);
        this.toggle_selected(card);
    }
    card_destroyed(card) {
        this._cards = this._cards.filter(function (el) { return el != card; });
        this._selected = this._selected.filter(function (el) { return el != card; });
        let new_score = this.score + 1;
        let percent = new_score / this._initial_card_count;
        this.set_score(new_score, percent);
        if (!this.clear_to_win) {
            this.win();
        }
        else if (this._cards.length == 0) {
            this.win();
        }
    }
    cards_generated(cards) {
        this._cards = [];
        this._selected = [];
        for (let i = 0; i < cards.length; i++) {
            this._cards.push(cards[i]);
        }
        this._initial_card_count = cards.length;
    }
    get_time_limit(difficulty) {
        const adj_difficulty = difficulty * this.difficulty_mod;
        const base_time_limit = super.get_time_limit(difficulty);
        if (adj_difficulty < 1) {
            return base_time_limit;
        }
        return Math.max(3000, super.get_time_limit(difficulty) - (Math.floor((adj_difficulty - 1) * 10) / 10) * 2000);
    }
    generate_initial_cards(rand, difficulty) {
        let cards = this.generator.getCards(rand, difficulty * this.difficulty_mod, this.min_cards, 16);
        let specs = [];
        let positions = [];
        for (let i = 0; i < 16; i++) {
            positions.push([this.fixed_x_position(i % 4), this.fixed_y_position(Math.floor(i / 4))]);
        }
        rand.shuffleArray(positions);
        for (let i = 0; i < cards.length; i++) {
            cards[i].x = positions[i % positions.length][0];
            cards[i].y = positions[i % positions.length][1];
            cards[i].rot = 0;
            specs.push(cards[i]);
        }
        return specs;
    }
    update_game(scene, now, delta, difficulty, mx, my, mdown) { }
    notify_card_destroy(cards_to_destroy) {
    }
    notify_card_deselect(cards_to_deselect) {
    }
    time_ran_out() { }
    cards_to_highlight_on_time_out() {
        return this.generator.cards_to_highlight();
    }
}
exports.CTGGameMode4x4 = CTGGameMode4x4;
